import { createVNode as a, mergeProps as i } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/InvoiceFilledStandard.js";
import d from "../components/PfIcon.js";
const r = (e, t) => {
  const o = {
    ...e,
    ...t.attrs
  };
  return a(d, i(o, {
    icon: n
  }), null);
};
r.displayName = "InvoiceFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
